import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, Transition as _Transition, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2455e543")

_pushScopeId("data-v-2455e543")
const _hoisted_1 = {
  key: 0,
  class: "f-caption"
}
const _hoisted_2 = { class: "inline-block w-full rounded-md shadow-sm" }
const _hoisted_3 = {
  key: 0,
  class: "f-placeholder truncate"
}
const _hoisted_4 = {
  key: 1,
  class: "f-placeholder truncate pr-3"
}
const _hoisted_5 = {
  key: 2,
  class: "f-placeholder truncate"
}
const _hoisted_6 = {
  key: 0,
  class: "mr-1"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ListboxButton = _resolveComponent("ListboxButton")
  const _component_ListboxOption = _resolveComponent("ListboxOption")
  const _component_ListboxOptions = _resolveComponent("ListboxOptions")
  const _component_Listbox = _resolveComponent("Listbox")

  return (_openBlock(), _createBlock("div", {
    class: ["w-full", _ctx.classList]
  }, [
    (_ctx.showTitle)
      ? (_openBlock(), _createBlock("span", _hoisted_1, _toDisplayString(_ctx.$t(_ctx.title)), 1))
      : _createCommentVNode("", true),
    _createVNode(_component_Listbox, {
      "model-value": _ctx.multipleSelect ? _ctx.selectMultipleItems : _ctx.selectedValue,
      as: "div",
      "data-testid": "app-dropdown-main",
      class: ["dropdown-main relative", {'is-selected' : _ctx.isSelected}],
      multiple: _ctx.multipleSelect ? true : undefined,
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
      "onUpdate:modelValue": _ctx.onChangeDropDown
    }, {
      default: _withId(({ open }) => [
        _createVNode("span", _hoisted_2, [
          _createVNode(_component_ListboxButton, {
            class: ["f-dropdown", _ctx.dropDownClass]
          }, {
            default: _withId(() => [
              (_ctx.selectedValue && !_ctx.multipleSelect)
                ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.selectedValue.name ? _ctx.$t(_ctx.selectedValue.name) : ''), 1))
                : (_ctx.selectMultipleItems.length > 0 && _ctx.multipleSelect)
                  ? (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.selectMultipleItems.map(value => value.name ? _ctx.$t(value.name) : '').join(', ')), 1))
                  : (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.$t(_ctx.placeholder)), 1)),
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          }, 8, ["class"])
        ]),
        _createVNode(_Transition, {
          "leave-active-class": "transition ease-in duration-100",
          "leave-from-class": "opacity-100",
          "leave-to-class": "opacity-0"
        }, {
          default: _withId(() => [
            open
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["select-list-container", _ctx.optionClass]
                }, [
                  _createVNode(_component_ListboxOptions, {
                    static: "",
                    class: "select-list"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.valueToShow, (item) => {
                        return (_openBlock(), _createBlock(_component_ListboxOption, {
                          key: item,
                          class: "focus:outline-none",
                          value: item
                        }, {
                          default: _withId(({ selected, active }) => [
                            _createVNode("div", {
                              class: `select-list-item ${active ?'text-htz-darkgrey' : 'text-htz-steel'}`
                            }, [
                              (item.name)
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    class: `${selected ? _ctx.selectedClass : _ctx.notSelectedClass} ${_ctx.selectMultipleItems.some(e => e.name === item.name) && _ctx.multipleSelect ? 'text-htz-red' : 'text-htz-steel'} block truncate  px-2`
                                  }, [
                                    (_ctx.selectMultipleItems.some(e => e.name === item.name) && _ctx.multipleSelect)
                                      ? (_openBlock(), _createBlock("span", _hoisted_6, "✓"))
                                      : _createCommentVNode("", true),
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t(item.name)), 1)
                                  ], 2))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["model-value", "class", "multiple", "onUpdate:modelValue"])
  ], 2))
})